// @flow

import { IdipUrl, motorPolicyBooklet, termsOfUseMotorUrl } from '../../../constants/externalLinks';

export type StaticLink = {
  label: string;
  url: string;
};

export const motorLinks: StaticLink[] = [
  {
    label: "Terms of use",
    url: termsOfUseMotorUrl
  },
  {
    label: "Policy Booklet",
    url: motorPolicyBooklet
  },
  {
    label: "Insurance product information documents Car – Popular",
    url: IdipUrl.Popular
  },
  {
    label: "Insurance product information documents Car – Prestige",
    url: IdipUrl.Prestige
  }
];

export const travelLinks: StaticLink[] = [];
